module.exports = __webpack_public_path__ + "img/home-07-cosmo-03-coc-01.4e0d4df0.jpg";